export default function ($translate) {
    return {
        KEYS: {
            RADIO: 'RADIO',
            CHECKBOX: 'CHECKBOX',
            FREE_TEXT: 'FREE_TEXT',
            FREE_TEXT_PREDEFINED: 'FREE_TEXT_PREDEFINED',
            SCALE: 'SCALE',
            MATRIX: 'MATRIX'
        },
        LABELS: {
            RADIO: $translate.instant('enums.multiple choice'),
            CHECKBOX: $translate.instant('enums.Multiple response'),
            FREE_TEXT: $translate.instant('enums.free text'),
            FREE_TEXT_PREDEFINED: $translate.instant('enums.free text predefined'),
            SCALE: $translate.instant('enums.Scale'),
            MATRIX: $translate.instant('enums.Matrix')
        },
        IMPORT_ALLOWED_LABELS: {
            RADIO: $translate.instant('enums.multiple choice'),
            FREE_TEXT: $translate.instant('enums.free text'),
            CHECKBOX: $translate.instant('enums.checkbox')
        },
        CSS_CLASSES: {
            RADIO: 'ico-radio',
            CHECKBOX: 'ico-cb',
            FREE_TEXT: 'ico-longtext',
            FREE_TEXT_PREDEFINED: 'ico-longtext',
            SCALE: 'ico-scale',
            MATRIX: 'ico-multi'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/questions/type/index.js